<template>
    <div class="content">
        <header v-if="type === 'signalMap'">Mapxus Positioning SDK</header>
        <header v-else>
            {{type === 'digitalMap' && device === 'rn' ? 'Mapxus Map React Native SDK' : 'Mapxus Map SDK'}}
        </header>
        <hr>
        <div class="word" v-html="content"></div>
    </div>
</template>

<script>
	import hljs from "highlight.js";
	import {mapState} from "vuex";
	import _find from "lodash/find";
	import _forEach from "lodash/forEach";

  const presetLanguages = ['javascript', 'python', 'objectivec', 'java', 'ruby', 'ebnf'];
  hljs.configure({ languages: presetLanguages });

	export default {
		name: "DocumentContent",
		props: {
			device: String
		},
		computed: mapState({
			type: state => state.document.type,
			content: state => state.document.content,
			menus: state => state.document.menus,
			backToTop: state => state.document.backToTop
		}),
		methods: {
			configAnchor() {
				_forEach(this.menus, menu => {
					var elements = this.$el.querySelectorAll(`h${menu.depth}`);
					var matchElement = _find(elements, elm => elm.innerHTML === menu.text);
					if (matchElement) {
						matchElement.setAttribute("id", menu.id);
					}
				});
			},
			configImg() {
				const width = this.$el.getBoundingClientRect().width - 60;
				this.$el.querySelectorAll("img").forEach(elm => {
					const img = new Image();
					img.src = elm.src;
					img.onload = () => {
						if (img.width < width) {
							elm.width = img.width;
						} else {
							elm.width = elm.parentNode.nodeName === "LI" ? width - 20 : width;
						}
					};
				});
			}
		},
		updated() {
			if (this.backToTop) {
				this.$el.scrollTop = 0;
			}
			this.$el.querySelectorAll("code").forEach(elm => {
        if (!elm.className) {
          elm.className = 'language-ebnf';
        }
        hljs.highlightElement(elm);
      });
			this.configAnchor();
			this.configImg();

			window.addEventListener("resize", this.configImg);
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    header {
        font-size: 3.5em;
    }

    hr {
        margin: 10px 0;
        height: 3px;
        background: rgba(96, 96, 96, 0.8);
        border: 0;
    }

    .content {
        font-size: 14px;
        height: 100vh;
        position: absolute;
        overflow: auto;
        width: calc(100vw - 256px);
        left: 256px;
        padding-top: 80px;
        padding-left: 30px;
        padding-right: 30px;
    }
</style>

<style>
    .word h1,
    .word h2,
    .word h3,
    .word h4,
    .word h5,
    .word h6 {
        margin: 16px 0 !important;
    }

    .word ul,
    .word ol {
        margin: 10px 0 !important;
        padding-left: 40px !important;
    }

    .word table {
        width: 100%;
        border-collapse: collapse;
    }

    .word th,
    .word td {
        padding: 5px !important;
        border: 1px solid;
    }

    .word h1::before,
    .word h2::before,
    .word h3::before {
        content: "";
        display: block;
        height: 80px;
        margin: -80px 0 0;
    }
</style>
